/*eslint perfectionist/sort-objects: "error"*/

export const LOCAL_STORAGE_KEYS = {
  bankAccountsSettlementDetails: "bank-accounts-settlement-details",
  clearingOptimisationToggleHidden: "clearing-optimisation-toggle-hidden",
  connectSettlementSettings: "connect-settlement-settings",
  ddkPayouts: "ddk-payouts",
  expandedPaymentRow: "expanded-payment-row",
  fxPayouts: "fx-payouts",
  helpHeader: "help-header",
  newCheckoutBranding: "new-checkout-branding",
  payoutsSCA: "payouts-sca",
  proxyLoginParametersKey: "proxy-login-parameters",
  refundsSCA: "refunds-sca",
  requestedFeatures: "requested-features",
  retriedPaymentReports: "retried-payment-reports",
  retriedPayoutReports: "retried-payout-reports",
  retriedRefundReports: "retried-refund-reports",
  retriedUserReports: "retried-user-reports",
  retriedVoltAccountReports: "retried-volt-account-reports",
  settlementLimit: "settlement-limit",
  settlementsList: "settlements-list",
  tokenOnVoltLicenceWaitingForTokenApproval:
    "token-on-volt-licence-waiting-for-token-approval",
  useMSWMockResponses: "use-msw-mock-responses",
  voltAccounts: "volt-accounts",
} as const;

export type LocalStorageItems = {
  [LOCAL_STORAGE_KEYS.clearingOptimisationToggleHidden]: boolean;
  [LOCAL_STORAGE_KEYS.proxyLoginParametersKey]: string;
  [LOCAL_STORAGE_KEYS.helpHeader]: HelpHeader;
  [LOCAL_STORAGE_KEYS.requestedFeatures]: RequestedFeatures;
  [LOCAL_STORAGE_KEYS.useMSWMockResponses]: boolean;
};

export type LocalStorageKeys = keyof typeof LOCAL_STORAGE_KEYS;
export type LocalStorageValues = (typeof LOCAL_STORAGE_KEYS)[LocalStorageKeys];

type HelpHeader = {
  visitedPlaces?: string[];
};

type RequestedFeatures = {
  requestedFeatures?: string[];
};
